exports = module.exports = require("../../node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul li[data-v-65a433d0]{list-style-type:none;padding:0;margin:0}ul[data-v-65a433d0]{padding:0;margin:0}.icon[data-v-65a433d0]{color:#2b6292;font-size:25px}.btn-view i[data-v-65a433d0]{color:#2b6292;font-size:18px}.btn-trash[data-v-65a433d0]{color:#f74040;font-size:18px}.assunto-text[data-v-65a433d0]{color:#2b6292;font-size:15px;font-weight:700;margin-left:25px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/css-loader@0.28.11/node_modules/css-loader?minimize!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65a433d0","scoped":true,"hasInlineConfig":false}!./node_modules/.pnpm/vue-loader@13.7.3_babel-core@6.26.3_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@3.12.0/node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/notification-history.vue
// module id = 1042
// module chunks = 0